"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserWorkspaceSettings = exports.UserWorkspaceSettingsProvider = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var UserWorkspaceSettingsContext = react_1.default.createContext(undefined);
UserWorkspaceSettingsContext.displayName = "UserWorkspaceSettingsContext";
/**
 * @internal
 */
exports.UserWorkspaceSettingsProvider = function (_a) {
    var children = _a.children, settings = _a.settings;
    return (react_1.default.createElement(UserWorkspaceSettingsContext.Provider, { value: settings }, children));
};
/**
 * @internal
 */
exports.useUserWorkspaceSettings = function () {
    return react_1.default.useContext(UserWorkspaceSettingsContext);
};
//# sourceMappingURL=UserWorkspaceSettingsContext.js.map